<template>
	<div class="projectDetail-container">
		<div v-loading="loading" class="project-detail-content">
			<!-- 详情-表格数据 -->
			<div class="common-detail-table">
				<table>
					<colgroup>
						<col width="180" />
						<col />
						<col width="180" />
						<col />
						<col width="180" />
						<col />
					</colgroup>
					<tr>
						<th>所在企业名称</th>
						<td>{{ detailInfo.constructionUnit }}</td>
						<th>所在企业组织机构代码</th>
						<td>{{ detailInfo.constructionUnitCode }}</td>
						<th>项目名称</th>
						<td>{{ detailInfo.projectName }}</td>
					</tr>
					<tr>
						<th>项目编码</th>
						<td>{{ detailInfo.projectCode }}</td>
						<th>项目地址</th>
						<td>{{ detailInfo.projectAddress }}</td>
						<th>建设单位</th>
						<td>{{ detailInfo.constructionUnit }}</td>
					</tr>
					<tr>
						<th>唯一代码</th>
						<td></td>
						<th>发生所在地市州</th>
						<td>{{ detailInfo.cityName }}</td>
						<th>发生所在区县</th>
						<td>{{ detailInfo.countyName }}</td>
					</tr>
					<tr>
						<th>奖励简介</th>
						<td colspan="1">{{ detailInfo.awardIntro }}</td>
						<th>表彰文号</th>
						<td colspan="3">{{ detailInfo.commendCode }}</td>
					</tr>
					<tr>
						<th>奖励日期</th>
						<td>{{ detailInfo.awardDate }}</td>
						<th>奖励决定内容</th>
						<td>{{ detailInfo.awardContent }}</td>
						<th>奖励部门</th>
						<td>{{ detailInfo.awardDept }}</td>
					</tr>
					<tr>
						<th>奖励部门级别</th>
						<td colspan="1">{{ detailInfo.awardDeptGrade }}</td>
						<th>登记部门</th>
						<td colspan="3">{{ detailInfo.registerDept }}</td>
					</tr>
				</table>
			</div>
			<!-- 未开通会员提示 -->
			<nonbind-vip v-if="isVip"></nonbind-vip>
			<!-- 未开通超级会员提示 -->
			<nonbind-svip v-if="isSVip"></nonbind-svip>
		</div>
	</div>
</template>

<script>
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import NonbindSvip from '@/components/NonBind/nonbindSVip.vue'
	import { personBehaviorRecordGetById } from '@/api/qualificationQuery/person'
	// 良好行为详情
	export default {
		name: 'GoodBehaviorDetail',
		components: { NonbindVip, NonbindSvip },
		props: {
			id: {
				type: String,
				required: true,
				default: ''
			}
		},
		data() {
			return {
				// 数据加载状态
				loading: false,
				isVip: false,
				isSVip: false,
				detailInfo: {},
				message: ''
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.initDetail()
		},
		methods: {
			initDetail() {
				this.loading = true
				const params = {
					personBehaviorId: this.id
				}
				personBehaviorRecordGetById(params)
					.then(response => {
						const { data, code, message } = response

						if (code === 6102) {
							this.isVip = true
						} else if (code === 6104) {
							// 当前是svip 权益已经使用完，提示次数已经用完了，请等待会员权益重置再使用
							this.$message.warning(message)
						} else if (code === 6105) {
							// 当前是vip 权益已经使用完，提示次数已经用完了，请用户升级为svip
							this.isSVip = true
						} else {
							if (data) {
								this.detailInfo = data
							}
						}
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/table.scss';
	@import '../../styles/project.scss';
</style>
